import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./index.css";

/* Actions */
import { setCrew, addCrew } from "../../../../redux/actions/admin";

/* Components */
import UsersListHeader from "../../../../components/UsersListHeader";
import UsersList from "../../../../components/UsersList";

/* API requests */
import { getCrew, getMoreCrew, searchCrew } from "../../../../api-requests/admin";

const PAGE_SIZE = 50;

const SearchIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <circle cx={11} cy={11} r={8} stroke="currentColor" strokeWidth={2} />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

class Crew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            searchResults: [],
            isFetchingSearchResults: false,
            isFetchingMore: false,
            hasMore: true,
        };
        this.searchTimeOut = null;
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);
        return getCrew().then(data => {
            this.props.setCrew(data);
            // First page came back full → likely more available.
            this.setState({ hasMore: Array.isArray(data) && data.length >= PAGE_SIZE });
        });
    }

    handleLoadMore = () => {
        if (this.state.isFetchingMore || !this.state.hasMore) return;
        const skip = (this.props.admin.crew || []).length;
        this.setState({ isFetchingMore: true });
        return getMoreCrew(skip).then(data => {
            const next = Array.isArray(data) ? data : [];
            if (next.length > 0) this.props.addCrew(next);
            this.setState({
                isFetchingMore: false,
                hasMore: next.length >= PAGE_SIZE,
            });
        });
    };

    handleSearch = (keyword) => {
        return this.setState({ keyword }, () => {
            if (keyword.length >= 5) {
                return this.setState({ isFetchingSearchResults: true }, () => {
                    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
                    this.searchTimeOut = setTimeout(() => {
                        return searchCrew(keyword)
                            .then(result => this.setState({ searchResults: result.users, isFetchingSearchResults: false }));
                    }, 1000);
                });
            }
            return this.setState({ searchResults: [], isFetchingSearchResults: false });
        });
    }

    handleUsersList = (crew, searchResults, keyword) => {
        if (searchResults.length > 0 && keyword.length >= 5) return searchResults;
        return crew;
    }

    render() {

        const crewCount = (this.props.admin.crew || []).length;

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">Crew</h1>
                        <p className="admin-page-subtitle">{crewCount > 0 ? `${crewCount} verified crew accounts.` : "Verified crew accounts."}</p>
                    </div>
                </header>

                <div className="admin-toolbar no-tabs">
                    <div className="admin-search">
                        <span className="admin-search-icon"><SearchIcon /></span>
                        <input
                            type="text"
                            value={this.state.keyword}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            placeholder="Search name or email"
                            className="admin-search-input"
                        />
                        {this.state.isFetchingSearchResults &&
                            <span className="admin-search-spinner">
                                <img src={require("../../../../assets/animations/blue-spinner.svg")} alt="" />
                            </span>
                        }
                    </div>
                </div>

                <UsersListHeader
                    status={false}
                    active={true}
                    col1={"Crew member"}
                    col2={"Last active"}
                    col3={"Signed up"}
                    col4={"Profile"}
                />

                {this.state.keyword.length > 4 && !this.state.isFetchingSearchResults && this.state.searchResults.length < 1 &&
                    <p className="admin-empty-state">No crew match this search.</p>
                }
                {this.state.keyword.length > 4 && !this.state.isFetchingSearchResults && this.state.searchResults.length > 0 &&
                    <UsersList
                        type={"crew"}
                        status={false}
                        active={true}
                        removeCandidateFromTheList={this.props.removeCandidateFromTheList}
                        isFetching={this.props.admin.isFetchingCrew}
                        users={this.handleUsersList(this.props.admin.crew, this.state.searchResults, this.state.keyword)}
                        isFetchingSearchResults={this.state.isFetchingSearchResults}
                    />
                }
                {this.state.keyword.length < 5 &&
                    <>
                        <UsersList
                            type={"crew"}
                            status={false}
                            active={true}
                            removeCandidateFromTheList={this.props.removeCandidateFromTheList}
                            isFetching={this.props.admin.isFetchingCrew}
                            users={this.handleUsersList(this.props.admin.crew, this.state.searchResults, this.state.keyword)}
                            isFetchingSearchResults={this.state.isFetchingSearchResults}
                        />
                        {this.state.hasMore && (this.props.admin.crew || []).length > 0 &&
                            <div className="admin-load-more">
                                <button
                                    type="button"
                                    className="admin-page-action admin-page-action--ghost"
                                    onClick={this.handleLoadMore}
                                    disabled={this.state.isFetchingMore}
                                >
                                    {this.state.isFetchingMore ? "Loading…" : "See more crew"}
                                </button>
                            </div>
                        }
                    </>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setCrew, addCrew }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Crew);
